import LastNetworkSync from './LastNetworkSync'

export default LastNetworkSync
